<template>
  <div class="xv_view" id="Quarantine_facilities_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Quarantine Facilities</label>
      </div>
      <div class="xv_actions">
        <button class="sec_btn m_r" @click="import_quarantine()">
          Import
          <span class="mdi mdi-cloud-download-outline"></span>
        </button>
        <button class="main_btn" @click="add_quarantine()">
          New Quarantine Faility
          <span class="mdi mdi-plus-thick"></span>
        </button>
      </div>
    </div>
    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Quarantine Facilities (7)</span>
        </div>
        <div class="table_search">
          <span class="mdi mdi-magnify"></span>
          <input type="text" placeholder="Search by Facility" />
        </div>
      </div>
      <table class="office_table">
        <thead>
          <tr>
            <th style="width:20%">Name</th>
            <th style="width:16%;text-align:center">State</th>
            <th style="width:16%;text-align:center">District</th>
            <th style="width:16%;text-align:center">City</th>
            <th style="width:16%;text-align:center">Doctors</th>
            <th style="width:16%;text-align:center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span id="global" @click="view_hospital">Global Hospitals</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>Siezure</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Tencent" @click="view_hospital">Pacifica Salud</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>Reius</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="carilione" @click="view_hospital">Carilione</span>
            </td>
            <td>
              <span>Switzerland</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>Venis</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="kaiser" @click="view_hospital">Kaiser</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Yishun</span>
            </td>
            <td>
              <span>Yoohan</span>
            </td>
            <td>
              <span>18</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="American Hospital" @click="view_hospital">American Hospital</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>Lebanon</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Fortis" @click="view_hospital">Fortis</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>Retro</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="mediclinic" @click="view_hospital">Mediclinic</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>Champeg</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Add modal -->
    <modal name="add_quarantine" transition="pop-out" :width="600" height="auto">
      <addQuarantine></addQuarantine>
    </modal>
    <!-- Import modal -->
    <modal name="import_quarantine" transition="pop-out" :width="600" height="auto">
      <importQuarentine></importQuarentine>
    </modal>
  </div>
</template>

<script>
import addQuarantine from "./add_quarantine/add_quarantine.vue";
import importQuarentine from "./import_quarantine/import_quarantine.vue";

export default {
  name: "Quarantine_facilities_G",
  components: {
    addQuarantine,
    importQuarentine
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    add_quarantine: function() {
      this.$modal.show("add_quarantine");
    },
    import_quarantine: function() {
      this.$modal.show("import_quarantine");
    },
    view_hospital: function(e) {
      var id = e.currentTarget.id;
      this.$router.push("/xv-admin-g/quarantine_facilities:" + id);
    }
  }
};
</script>
